<template>
  <div>
    <vx-card title="Children" class="mt-3">
      <vs-button
        v-if="multi_user == 1"
        type="border"
        color="primary"
        style="font-size: 13.8px; padding: 7px; float: right; margin-top: -3.2%"
        @click="addpopup = !addpopup"
      >
        Add
      </vs-button>
      <div class="vx-row">
        <vs-table :data="localvalue" class="cstm_vuexy_table w-full">
          <template slot="thead">
            <vs-th sort-key="index">Index</vs-th>
            <vs-th style="min-width: 160px" sort-key="lead_first_name"
              >Full Name</vs-th
            >
            <vs-th style="min-width: 105px" sort-key="lead_first_name"
              >First Name</vs-th
            >
            <vs-th style="min-width: 120px" sort-key="lead_middle_name"
              >Middle Name</vs-th
            >
            <vs-th style="min-width: 105px" sort-key="lead_last_name"
              >Last Name</vs-th
            >
            <vs-th style="min-width: 130px" sort-key="number"
              >Phone Number</vs-th
            >
            <vs-th style="min-width: 150px" sort-key="email">Email</vs-th>
            <vs-th style="min-width: 100px" sort-key="address1"
              >Address 1</vs-th
            >
            <vs-th style="min-width: 100px" sort-key="address2"
              >Address 2</vs-th
            >
            <vs-th style="min-width: 100px" sort-key="state">State</vs-th>
            <vs-th style="min-width: 100px" sort-key="city">City</vs-th>
            <vs-th style="min-width: 100px" sort-key="zip">Zip</vs-th>
            <vs-th style="min-width: 100px" sort-key="country_name"
              >Country</vs-th
            >
            <vs-th style="min-width: 100px" sort-key="action">Action</vs-th>
          </template>

          <template>
            <vs-tr :key="indextr" v-for="(item, indextr) in localvalue">
              <vs-td :data="localvalue[indextr].lead_first_name">
                {{ indextr + 1 }}
              </vs-td>
              <vs-td :data="localvalue[indextr].first_name">
                <span
                  class="cursor-pointer"
                  style="color: blue"
                  @click="gotoChild(localvalue[indextr].leads_id)"
                  >{{ localvalue[indextr].lead_first_name }}
                  {{ localvalue[indextr].lead_last_name }}
                </span>
              </vs-td>
              <vs-td :data="localvalue[indextr].lead_first_name">
                {{ localvalue[indextr].lead_first_name }}
              </vs-td>

              <vs-td :data="localvalue[indextr].lead_middle_name">
                {{ localvalue[indextr].lead_middle_name }}
              </vs-td>
              <vs-td :data="localvalue[indextr].lead_last_name">
                {{ localvalue[indextr].lead_last_name }}
              </vs-td>

              <vs-td :data="localvalue[indextr].phone">
                {{ localvalue[indextr].phone }}
              </vs-td>

              <vs-td :data="localvalue[indextr].email">
                {{ localvalue[indextr].email }}
              </vs-td>
              <vs-td :data="localvalue[indextr].lead_address1">
                {{ localvalue[indextr].lead_address1 }}
              </vs-td>
              <vs-td :data="localvalue[indextr].lead_address2">
                {{ localvalue[indextr].lead_address2 }}
              </vs-td>
              <vs-td :data="localvalue[indextr].lead_state">
                {{ localvalue[indextr].lead_state }}
              </vs-td>
              <vs-td :data="localvalue[indextr].lead_city">
                {{ localvalue[indextr].lead_city }}
              </vs-td>
              <vs-td :data="localvalue[indextr].lead_zip">
                {{ localvalue[indextr].lead_zip }}
              </vs-td>
              <vs-td :data="localvalue[indextr].country_details.country_name">
                {{ localvalue[indextr].country_details.country_name }}
              </vs-td>
              <!-- <vs-td :data="localvalue[indextr].created_at">
                {{ localvalue[indextr].created_at|moment('MMM-YYYY') }}
              </vs-td>  -->
              <vs-td :data="localvalue[indextr]">
                <div class="flex">
                  <toggle-button
                    :value="localvalue[indextr].is_active === '1'"
                    :color="{
                      checked: '#35C76F',
                      unchecked: '#EA5455',
                      disabled: '#CCCCCC'
                    }"
                    class="mt-3 mr-1"
                    @change="handleToggle(indextr)"
                  />
                  <vs-button
                    type="filled"
                    :disabled="localvalue[indextr].is_active === '1'"
                    @click="remove(indextr)"
                    icon="delete"
                    color="danger"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>

    <vs-popup
      classContent="popup-example"
      title="Delete"
      :active.sync="deletepopup"
    >
      <h4>Do you want to delete this ?</h4>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click="handleDelete">Confirm</vs-button>
        <vs-button type="border" color="danger" @click="deletepopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      title="Add Child"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add">
        <vs-row>
          <vs-checkbox
            v-model="sameasparentAddress"
            @change="abc"
            class="custom_Input"
            value="same"
            style="width: 100%"
            >Same as Parent's Address</vs-checkbox
          >
          <vs-col
            :vs-xs="12"
            :vs-md="12"
            :vs-lg="12"
            class="p-2"
            v-for="childfield in staticChildFields"
            :key="childfield.id"
          >
            <label class="vs-input--label w-full"
              >{{ childfield.field_label
              }}<span v-if="childfield.enabled_child" class="required"></span
            ></label>
            <vs-input
              v-if="childfield.field_name != 'platform_customer_countries_id'"
              v-model="minor[childfield.field_name]"
              style="width: 100%"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :data-vv-name="childfield.field_label"
              :name="childfield.field_label"
              class="custom_Input"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
            />

            <v-select
              v-else
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              v-model="minor[childfield.field_name]"
              v-validate="childfield.enabled_child == true ? 'required' : ''"
              :reduce="(option) => option.id"
              label="country_name"
              :name="childfield.field_label"
              :options="countryList"
              style="width: 100%"
            />
            <span
              v-show="errors.has(`add.${childfield.field_label}`)"
              class="text-danger"
              >{{ errors.first(`add.${childfield.field_label}`) }}</span
            >
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSave">Save</vs-button>
        <vs-button type="border" color="danger" @click="handleAddCancel"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { createMinorApi, DeleteMinor, updateMinor } from '@/api/leads'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  name: 'address',
  components: {
    ToggleButton,
    vSelect
  },
  props: {
    staticChildFields: {
      required: true,
      type: Array,
      default: () => []
    },
    multi_user: {
      type: Number,
      required: true
    },
    value: {
      required: true,
      type: Array,
      default: () => []
    },
    parent_details: {
      required: true,
      type: Object,
      default: () => { }
    },
    countryList: {
      required: true,
      type: Array,
      default: () => []
    },
    parent_id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      leads: [],
      sameasparentAddress: false,
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      minor: {
        lead_first_name: null,
        lead_middle_name: null,
        lead_last_name: null,
        email: null,
        mobile: null,
        lead_address1: null,
        lead_address2: null,
        lead_state: null,
        lead_city: null,
        lead_zip: null,
        platform_customer_countries_id: null
      },
      editIndex: null,
      deleteindex: false
    }
  },
  computed: {
    localvalue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    abc () {
      if (this.sameasparentAddress === true) {
        this.minor.lead_address1 = this.parent_details.lead_address1
        this.minor.lead_address2 = this.parent_details.lead_address2
        this.minor.lead_state = this.parent_details.lead_state
        this.minor.lead_zip = this.parent_details.lead_zip
        this.minor.lead_city = this.parent_details.lead_city
        this.minor.platform_customer_countries_id =
          this.parent_details.platform_customer_countries_id
      }
    },
    handlechange (index) {
      this.localvalue.map((item) => {
        item.defaults = 0
      })
      this.localvalue[index].defaults = 1
    },
    async handleSave () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          //
          const payload = {
            leads_id: this.parent_id,
            lead_first_name: this.minor.lead_first_name,
            lead_last_name: this.minor.lead_last_name,
            lead_middle_name: this.minor.lead_middle_name,
            email: this.minor.email,
            phone: this.minor.phone,
            lead_address1: this.minor.lead_address1,
            lead_address2: this.minor.lead_address2,
            lead_city: this.minor.lead_city,
            lead_state: this.minor.lead_state,
            lead_zip: this.minor.lead_zip,
            platform_customer_countries_id:
              this.minor.platform_customer_countries_id
          }
          createMinorApi(payload, this.$store.getters.customerId)
            .then((data) => {
              // const __tmp = this.localvalue
              const child = data.data.data.minor_details
              this.$set(this.localvalue, this.localvalue.length, child)
              this.minor = {
                lead_first_name: null,
                lead_middle_name: null,
                lead_last_name: null,
                email: null,
                mobile: null,
                lead_address1: null,
                lead_address2: null,
                lead_state: null,
                lead_city: null,
                lead_zip: null,
                platform_customer_countries_id: null
              }
              this.addpopup = false
              this.showSuccessMessage(
                'success',
                'Child Added Successfully',
                'success'
              )
              //
            })
            .catch((api_error) => {
              for (const [key, value] of Object.entries(
                api_error.data.errors
              )) {
                this.showSuccessMessage('Error', `${value[0]}`, 'danger')
              }
            })
        }
      })
    },
    handleAddCancel () {
      this.addpopup = false
      this.minor = {
        lead_first_name: null,
        lead_middle_name: null,
        lead_last_name: null,
        email: null,
        mobile: null,
        lead_address1: null,
        lead_address2: null,
        lead_state: null,
        lead_city: null,
        lead_zip: null,
        platform_customer_countries_id: null
      }
    },
    gotoChild (id) {
      this.$router.push({
        name: 'lead-user-details',
        params: { lead_user_id: id }
      })
    },
    remove (index) {
      if (this.localvalue[index].is_active === '1') {
        this.$vs.notify({
          title: 'Warning',
          text: 'Deactivate Account First',
          ...this.warnProp()
        })
      } else {
        this.deletepopup = true
        this.deleteindex = index
      }
    },
    async handleDelete () {
      let payload = {}

      payload = {
        leads_id: this.localvalue[this.deleteindex].leads_id,
        parent_leads_id: this.parent_id
      }
      const data = await DeleteMinor(payload, this.$store.getters.customerId)

      this.$vs.notify({
        title: 'Deleted',
        text: 'User deleted Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
      const __temp = this.localvalue
      __temp.splice(this.deleteindex, 1)
      this.deletepopup = false
    },
    async handleToggle (index) {
      try {
        const payload = {
          leads_id: this.localvalue[index].leads_id,
          parent_leads_id: this.parent_id,
          updated_field: {
            is_active: this.localvalue[index].is_active === '1' ? 0 : 1
          }
        }

        const { data } = await updateMinor(
          payload,
          this.$store.getters.customerId
        )
        this.$vs.notify({
          title: 'Success',
          text: `User ${payload.updated_field.is_active === 0 ? 'deactivated' : 'activated'
            } Successfully`,
          ...this.successProp()
        })
        if (index === 0 && payload.updated_field.is_active === 0) {
          this.localvalue.map((item) => {
            if (item.leads_id == payload.leads_id) {
              item.is_active = 0
            }
          })
        }
        this.localvalue[index].is_active = data.data.minor_details.is_active
      } catch (e) { }
    }
  }
}
</script>
<style scoped>
.required:after {
  content: ' *';
  color: red;
}
</style>
